import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { SignIn, ShieldCheck, SignOut } from "@phosphor-icons/react";

export function Logo({ small = false }) {
  return (
    <Link to="/" data-testid="logo-link" className="inline-flex items-center gap-2 group">
      <span aria-hidden className="grid place-items-center w-7 h-7 bg-persimmon text-white font-display font-black text-[15px] leading-none group-hover:rotate-6 transition-transform">C</span>
      <span className={`font-display font-black tracking-tightest text-ink ${small ? "text-base" : "text-lg"} group-hover:text-ink-2 transition-colors`}>
        CliqCommerce
      </span>
    </Link>
  );
}

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-paper/85 backdrop-blur-xl border-b border-rule">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-14 flex items-center justify-between">
        <div className="flex items-center gap-10">
          <Logo />
          <nav className="hidden md:flex items-center gap-7 label-mono">
            <NavLink to="/" end className={({ isActive }) =>
              `transition-colors ${isActive ? "text-ink" : "text-ink/60 hover:text-ink"}`
            } data-testid="nav-home">Home</NavLink>
            <NavLink to="/blog" className={({ isActive }) =>
              `transition-colors ${isActive ? "text-ink" : "text-ink/60 hover:text-ink"}`
            } data-testid="nav-blog">Journal</NavLink>
            {user && (
              <NavLink to="/dashboard" className={({ isActive }) =>
                `transition-colors ${isActive ? "text-ink" : "text-ink/60 hover:text-ink"}`
              } data-testid="nav-dashboard">Workspace</NavLink>
            )}
            <NavLink to="/waitlist" className={({ isActive }) =>
              `transition-colors ${isActive ? "text-ink" : "text-ink/60 hover:text-ink"}`
            } data-testid="nav-waitlist">Waitlist</NavLink>
          </nav>
        </div>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              {user.role === "admin" && (
                <Button
                  variant="outline"
                  size="sm"
                  data-testid="nav-admin-btn"
                  onClick={() => navigate("/admin")}
                  className="hidden sm:inline-flex"
                >
                  <ShieldCheck weight="bold" className="w-4 h-4 mr-1.5" />Admin
                </Button>
              )}
              <Button
                variant="ghost"
                size="sm"
                data-testid="nav-logout-btn"
                onClick={async () => { await logout(); navigate("/"); }}
              >
                <SignOut className="w-4 h-4 mr-1.5" /> Log out
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                size="sm"
                data-testid="nav-login-btn"
                onClick={() => navigate("/login")}
              >
                <SignIn className="w-4 h-4 mr-1.5" /> Log in
              </Button>
              <Button
                size="sm"
                data-testid="nav-signup-btn"
                onClick={() => navigate("/signup")}
              >
                Get started →
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
